import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Box, Button, Typography, useTheme } from '@mui/material';

import { StatusFilter } from '@/lib/filter/stakingPoolState';
import { unixToDate } from '@/lib/days';
import { ResGetPoolDetailsAndEvmTxHistory } from '@/types';
import SymbolSvg from '@/assets/assetfi/Symbol';

const columns: GridColDef[] = [
  {
    flex: 1,
    minWidth: 200,
    field: 'name',
    headerName: 'Pool Name',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    editable: false,
    renderCell: (params) => (
      <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
        <SymbolSvg width={16} height={16} />
        <Typography variant="body2" color={'#6f6f6f'}>
          {params.value}
        </Typography>
      </Box>
    ),
  },
  {
    minWidth: 150,
    field: 'functionName',
    headerName: 'Status',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    editable: false,
    valueGetter(params) {
      const re = params.row.methodId === '0x8448705b' ? '0x8448705b' : params.value;
      return StatusFilter(re);
    },
  },
  // {
  //   minWidth: 300,
  //   field: 'amount',
  //   headerName: 'Amount',
  //   headerAlign: 'center',
  //   align: 'center',
  //   sortable: false,
  // },
  {
    flex: 1,
    minWidth: 300,
    field: 'timeStamp',
    headerName: 'Date',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
    valueGetter(params) {
      return unixToDate(params.value);
    },
  },
  {
    minWidth: 100,
    field: 'hash',
    headerName: 'Tx',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    renderCell: (params) => (
      <Button color="primary" onClick={() => handleButtonClick(params.value)}>
        ↗
      </Button>
    ),
  },
];

const handleButtonClick = (aData: string) => {
  const src =
    process.env.NODE_ENV === 'development'
      ? `https://amoy.polygonscan.com/tx/${aData}`
      : `https://polygonscan.com/tx/${aData}`;
  window.open(src);
};

const PortfolioTable = ({ aList }: { aList: ResGetPoolDetailsAndEvmTxHistory[] | null }) => {
  // theme
  const theme = useTheme();
  if (!aList) {
    return;
  }
  return (
    <Box
      sx={{
        maxHeight: 426,
        width: '100%',
        '& .MuiDataGrid-root': {
          borderRadius: '10px',
          overflow: 'hidden', // To ensure the border-radius is applied correctly
        },
        '& .MuiDataGrid-main': {
          borderRadius: '10px', // Outer border radius
        },
        '& .MuiDataGrid-columnHeaders': {
          borderTopLeftRadius: '10px',
          borderTopRightRadius: '10px',
        },
        '& .MuiDataGrid-virtualScroller': {
          borderBottomLeftRadius: '10px',
          borderBottomRightRadius: '10px',
        },
        '& .MuiDataGrid-columnHeaderTitleContainerContent': {
          paddingRight: '5px',
        },
      }}
    >
      <DataGrid
        pageSize={20}
        paginationMode="client"
        autoHeight
        sx={{
          boxShadow: '0px 0px 4px 0px #00000026',
          '& .MuiDataGrid-columnHeader': {
            height: '46px !important',
            background: theme.brand.primary,
            color: '#ffffff',
            typography: 'subtitle2',
          },
          '& .MuiDataGrid-columnHeader:focus': {
            outline: 'none',
          },
          '& .MuiDataGrid-columnHeader:selected': {
            outline: 'none',
          },
          '& .MuiDataGrid-cell:focus': {
            outline: 'none',
          },
          '& .MuiDataGrid-cell': {
            typography: 'body2',
            color: theme.greyscale.grey3,
            display: 'flex',
            alignItems: 'center',
          },
          '& .MuiDataGrid-columnSeparator': {
            display: 'none',
          },
        }}
        rows={aList}
        columns={columns}
        getRowId={(row) => row.hash}
      />
    </Box>
  );
};

export default PortfolioTable;
